"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var GlobalFooter_component_exports = {};
__export(GlobalFooter_component_exports, {
  GlobalFooter: () => GlobalFooter
});
module.exports = __toCommonJS(GlobalFooter_component_exports);
var import_react = __toESM(require("react"));
var import_constants = require("../../../constants");
var import_atoms = require("../../atoms");
var import_react_i18next = require("react-i18next");
var import_Link = require("../../atoms/Link/Link.component");
var import_Icon = require("../../atoms/Icon/Icon.component");
var import_GlobalFooter = require("./GlobalFooter.styled");
var import_i18n = __toESM(require("../../../i18n"));
function GlobalFooter(_ref) {
  var _ref$id = _ref.id, id = _ref$id === void 0 ? "globalFooter" : _ref$id, _ref$isHabitatContext = _ref.isHabitatContext, isHabitatContext = _ref$isHabitatContext === void 0 ? true : _ref$isHabitatContext, _ref$stackOrder = _ref.stackOrder, stackOrder = _ref$stackOrder === void 0 ? 300 : _ref$stackOrder, _ref$position = _ref.position, position = _ref$position === void 0 ? "relative" : _ref$position, darkMode = _ref.darkMode;
  var currentYear = (/* @__PURE__ */ new Date()).getFullYear();
  var _useTranslation = (0, import_react_i18next.useTranslation)(), t = _useTranslation.t;
  var Links = function Links2() {
    return /* @__PURE__ */ import_react.default.createElement("ul", null, import_constants.links.map(function(link) {
      return /* @__PURE__ */ import_react.default.createElement("li", {
        key: t(link.text)
      }, /* @__PURE__ */ import_react.default.createElement(import_Link.Link, {
        "data-dp-analytics-id": link.dataDpAnalyticsId,
        href: link.href,
        target: "_blank",
        key: t(link.text)
      }, /* @__PURE__ */ import_react.default.createElement("span", null, t(link.text)), /* @__PURE__ */ import_react.default.createElement(import_Icon.Icon, {
        icon: "redirect-link",
        "aria-label": "Opens in new tab",
        size: 12
      }), /* @__PURE__ */ import_react.default.createElement(import_atoms.ScreenReaderOnlyText, {
        text: "Opens in new tab"
      })));
    }));
  };
  return /* @__PURE__ */ import_react.default.createElement(import_GlobalFooter.StyledFooter, {
    id,
    isHabitatContext,
    stackOrder,
    position,
    "aria-label": t("base_constant_footer"),
    darkMode,
    "data-testid": "globalFooterWrapper"
  }, /* @__PURE__ */ import_react.default.createElement(import_react_i18next.I18nextProvider, {
    i18n: import_i18n.default
  }, /* @__PURE__ */ import_react.default.createElement(import_atoms.ScreenReaderOnlyText, {
    "data-testid": "globalFooterTextOnly",
    text: t("base_constant_footer")
  }), /* @__PURE__ */ import_react.default.createElement(import_GlobalFooter.LinksContainer, {
    "data-testid": "globalFooterLinksContainer",
    "aria-label": t("dp_core_footer_secondary")
  }, /* @__PURE__ */ import_react.default.createElement(Links, null)), /* @__PURE__ */ import_react.default.createElement(import_GlobalFooter.CopyRigthContainer, {
    darkMode,
    isHabitatContext
  }, /* @__PURE__ */ import_react.default.createElement("p", null, " \xA9 ".concat(currentYear, " GREAT MINDS PBC")))));
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  GlobalFooter
});
//# sourceMappingURL=GlobalFooter.component.js.map